import type { Lead, TextShortcut, WhatsappChat } from "../types.ts";

export type ShortcutExpansionContext = {
  lead?: Lead | null;
  chat?: WhatsappChat | null;
};

export function normalizeShortcutTrigger(value: string): string {
  const raw = String(value || "").trim().toLowerCase();
  return raw.startsWith("/") ? raw.slice(0, 64) : `/${raw}`.slice(0, 64);
}

export function findShortcutByTrigger(shortcuts: TextShortcut[], value: string): TextShortcut | null {
  const trigger = normalizeShortcutTrigger(value);
  const matches = shortcuts.filter((item) => normalizeShortcutTrigger(item.trigger) === trigger);
  return matches.find((item) => item.scope !== "global") || matches[0] || null;
}

export function expandShortcutText(text: string, context: ShortcutExpansionContext = {}): string {
  const lead = context.lead;
  const chat = context.chat;
  const name = stringValue(lead?.name) || stringValue(chat?.pushName) || stringValue(chat?.subject);
  const phone = stringValue(lead?.phone) || stringValue(chat?.phone) || phoneFromJid(stringValue(chat?.chatJid));

  return String(text || "")
    .replace(/\{\{nome\}\}/gi, name)
    .replace(/\{\{telefone\}\}/gi, phone)
    .replace(/\{\{curso\}\}/gi, stringValue(lead?.course))
    .replace(/\{\{valor\}\}/gi, lead?.value == null ? "" : String(lead.value))
    .trim();
}

export function shortcutSearchText(shortcut: TextShortcut): string {
  return [
    shortcut.trigger,
    shortcut.title,
    shortcut.body,
    shortcut.scope,
  ].join(" ").replace(/\s+/g, " ").trim().toLowerCase();
}

export function shortcutPreview(shortcut: TextShortcut): string {
  const text = String(shortcut.body || "").replace(/\s+/g, " ").trim();
  return text.length > 140 ? `${text.slice(0, 137)}...` : text;
}

export function canDeleteShortcut(shortcut: TextShortcut, role?: string): boolean {
  return shortcut.scope !== "global" || role === "admin";
}

function stringValue(value: unknown): string {
  return typeof value === "string" ? value.trim() : "";
}

function phoneFromJid(jid: string): string {
  if (!jid || jid.endsWith("@g.us") || jid.endsWith("@lid")) return "";
  return jid.split("@")[0]?.split(":")[0] || "";
}
